import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const OrderSummary = ({ isVisible = true }) => {
  // Mock cart items
  const cartItems = [
    {
      id: 1,
      name: 'Fresh Organic Bananas',
      image: 'https://images.unsplash.com/photo-1571771894821-ce9b6c11b08e?w=400',
      price: 2.99,
      quantity: 3
    },
    {
      id: 2,
      name: 'Whole Milk - 1 Gallon',
      image: 'https://images.unsplash.com/photo-1563636619-e9143da7973b?w=400',
      price: 3.49,
      quantity: 1
    },
    {
      id: 3,
      name: 'Free Range Eggs - Dozen',
      image: 'https://images.unsplash.com/photo-1582722872445-44dc5f7e3c8f?w=400',
      price: 4.99,
      quantity: 2
    }
  ];

  const subtotal = cartItems.reduce((sum, item) => sum + (item.price * item.quantity), 0);
  const deliveryFee = 2.99;
  const tax = subtotal * 0.08;
  const discount = 5.00; // Mock discount
  const total = subtotal + deliveryFee + tax - discount;

  if (!isVisible) return null;

  return (
    <div className="bg-surface border border-border rounded-card p-6 sticky top-24">
      <h3 className="font-heading font-heading-semibold text-lg text-text-primary mb-4">
        Order Summary
      </h3>
      
      {/* Cart Items */}
      <div className="space-y-3 mb-6">
        {cartItems.map((item) => (
          <div key={item.id} className="flex items-center space-x-3">
            <div className="relative">
              <Image
                src={item.image}
                alt={item.name}
                className="w-12 h-12 object-cover rounded-input"
              />
              <span className="absolute -top-2 -right-2 bg-primary text-primary-foreground text-xs font-data font-data-medium rounded-full w-5 h-5 flex items-center justify-center">
                {item.quantity}
              </span>
            </div>
            <div className="flex-1 min-w-0">
              <h4 className="font-body-semibold text-sm text-text-primary truncate">
                {item.name}
              </h4>
              <p className="font-data font-data-medium text-primary text-sm">
                ${item.price.toFixed(2)}
              </p>
            </div>
            <div className="text-right">
              <p className="font-data font-data-medium text-text-primary text-sm">
                ${(item.price * item.quantity).toFixed(2)}
              </p>
            </div>
          </div>
        ))}
      </div>

      {/* Pricing Breakdown */}
      <div className="space-y-3 border-t border-border pt-4">
        <div className="flex justify-between text-sm">
          <span className="text-text-secondary">Subtotal</span>
          <span className="font-data font-data-medium text-text-primary">
            ${subtotal.toFixed(2)}
          </span>
        </div>
        
        <div className="flex justify-between text-sm">
          <span className="text-text-secondary">Delivery</span>
          <span className="font-data font-data-medium text-text-primary">
            ${deliveryFee.toFixed(2)}
          </span>
        </div>
        
        <div className="flex justify-between text-sm">
          <span className="text-text-secondary">Tax</span>
          <span className="font-data font-data-medium text-text-primary">
            ${tax.toFixed(2)}
          </span>
        </div>
        
        <div className="flex justify-between text-sm">
          <span className="text-success">Discount</span>
          <span className="font-data font-data-medium text-success">
            -${discount.toFixed(2)}
          </span>
        </div>
        
        <div className="border-t border-border pt-3">
          <div className="flex justify-between">
            <span className="font-heading font-heading-semibold text-text-primary">
              Total
            </span>
            <span className="font-data font-data-medium text-xl text-primary">
              ${total.toFixed(2)}
            </span>
          </div>
        </div>
      </div>

      {/* Estimated Delivery */}
      <div className="mt-6 p-3 bg-background rounded-card">
        <div className="flex items-center space-x-2">
          <Icon name="Truck" size={16} className="text-primary" />
          <span className="font-body-semibold text-sm text-text-primary">
            Estimated Delivery
          </span>
        </div>
        <p className="text-text-secondary text-sm mt-1">
          Tomorrow, 9:00 AM - 11:00 AM
        </p>
      </div>

      {/* Security Badge */}
      <div className="mt-4 flex items-center justify-center space-x-2 text-text-secondary text-xs">
        <Icon name="Shield" size={14} />
        <span>Secure Checkout</span>
      </div>
    </div>
  );
};

export default OrderSummary;